import { fromJS } from 'immutable';
import _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState } from '@constants';

import * as actions from '../actions/global';

const initialState = fromJS({
  preference: {},
  dropdowns: { data: {}, state: null },
});

const GlobalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.PREFERENCE_FETCH_START: {
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    }
    case actions.PREFERENCE_FETCH_SUCCESS: {
      return state
        .setIn(['preference', 'state'], fetchingState.LOADED)
        .setIn(
          ['preference', 'data'],
          fromJS(_.get(action, 'data.results[0].preference', {})),
        );
    }
    case actions.PREFERENCE_FETCH_ERROR: {
      return state.setIn(['preference', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_DROPDOWNS[START]:
      return state.setIn(['dropdowns', 'state'], fetchingState.FETCHING);
    case actions.FETCH_DROPDOWNS[SUCCESS]:
      var newState = state.setIn(['dropdowns', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['dropdowns', 'data', action.name],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.FETCH_DROPDOWNS[ERROR]:
      return state.setIn(['dropdowns', 'state'], fetchingState.ERROR);
    default: {
      return state;
    }
  }
};

export default GlobalReducer;
